<template>
  <div v-if="selectedCount > 0" class="base-bulk-actions">
    <div class="base-bulk-actions__left">
      <a-checkbox
        :checked="allSelected"
        :indeterminate="!allSelected"
        @change="handleToggleAll"
      />
      <span class="base-bulk-actions__count">
        {{ selectedCount }} {{ countLabel }}
      </span>
    </div>

    <div class="base-bulk-actions__right">
      <template v-for="(action, index) in actions">
        <span
          v-if="index > 0"
          :key="`divider-${action.key}`"
          class="base-bulk-actions__divider"
        />

        <button
          :key="action.key"
          type="button"
          class="base-bulk-actions__action"
          :class="`base-bulk-actions__action--${action.variant || 'neutral'}`"
          :disabled="isBusy"
          @click="$emit('action', action.key)"
        >
          <a-icon
            :type="action.loading ? 'loading' : action.icon"
            :theme="action.loading ? undefined : 'filled'"
          />
          {{ action.label }}
        </button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseBulkActionsBar",
  props: {
    selectedCount: {
      type: Number,
      default: 0,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    actions: {
      type: Array,
      default: () => [],
    },
    countLabel: {
      type: String,
      default: "selecionados",
    },
  },
  computed: {
    allSelected() {
      return this.totalCount > 0 && this.selectedCount === this.totalCount;
    },
    isBusy() {
      return this.actions.some((action) => action.loading);
    },
  },
  methods: {
    handleToggleAll(e) {
      this.$emit("toggle-all", e.target.checked);
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/shared/styles/variables.less";

.base-bulk-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: @font-primary;
  background-color: @color-bg-info;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 16px;

  &__left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__count {
    font-size: 14px;
    color: @color-text-dark;
    font-weight: 500;
  }

  &__right {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  &__divider {
    width: 1px;
    height: 16px;
    background-color: darken(@color-bg-info, 15%);
  }

  &__action {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: none;
    border: none;
    padding: 0;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;

    &--success {
      color: @color-success;
    }

    &--danger {
      color: @color-danger;
    }

    &--neutral {
      color: @color-tag-text;
    }

    &:hover {
      opacity: 0.8;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;

      &:hover {
        opacity: 0.5;
      }
    }
  }
}
</style>
